import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=dc0f80a0"
import script from "./Currency.vue?vue&type=script&lang=ts"
export * from "./Currency.vue?vue&type=script&lang=ts"
import style0 from "./Currency.vue?vue&type=style&index=0&id=dc0f80a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports